import { contentMap } from './data-business';
import { premiumContentMap } from './data-premium';
import { mapItemTemplate } from './mapItemTemplate';
import { ev, isTablet } from '../../utils';
import $ from 'jquery';
import gsap from 'gsap';

import { addHeroContentAnimation } from '../heroContentAnimation';

import { lottieCulinary } from '../lottie';

export default () => {
	const container = document.querySelector('[data-banners]');
	if (!container) return;

	const allQuestions = contentMap.length;
	const infoList = document.querySelector('[data-banners="infoList"]');

	const previewBanner = container.querySelector('[data-banners="previewBanner"]');
	const btnShow = container.querySelector('[data-banners="btnShow"]');
	let btnToHint = container.querySelectorAll('[data-banners="btnToHint"]');
	const btnNext = container.querySelector('[data-banners="btnNext"]');
	const $btnDish = container.querySelectorAll('[data-banners="btnDish"]');
	const mapContainer = container.querySelector('[data-banners="mapContainer"]');
	const mapContent = container.querySelector('[data-banners="mapContent"]');
	// const mapContentWrapper = container.querySelector('[data-banners="mapContentWrapper"]');
	const mapContentInner = container.querySelector('[data-banners="mapContentInner"]');
	const mapMobileScroll = container.querySelector('[data-banners="mapMobileScroll"]');
	let headerTxt = container.querySelectorAll('[data-banners="headerTxt"]');
	const mapOverlayText = container.querySelector('[data-banners="mapOverlayText"]');
	const mapBox = container.querySelector('[data-banners="mapBox"]');
	// const mapList = container.querySelector('[data-banners="mapList"]');
	// const mapItems = mapList.querySelectorAll('[data-banners]');
	let infoListItems = infoList.querySelectorAll('[data-banners="infoListItem"]');
	// const titleFirstBanner = container.querySelector('[data-banners="titleFirstBanner"]');
	// const textFirstBanner = container.querySelector('[data-banners="textFirstBanner"]');
	let question = container.querySelectorAll('[data-banners="question"]');
	const mapWrap = container.querySelector('[data-quiz="map"]');

	let lottieAnimations;

	let heroTimeline = gsap.timeline();

	let currentQuestion = 0;
	let currentContent;

	function incrementQuestion() {
		currentQuestion += 1;
	}

	let correctCount = 1;

	btnNext.addEventListener('click', (e) => {
		e.preventDefault();

		// console.log(currentQuestion);

		const timelineClose = gsap.timeline();
		const timelineLast = gsap.timeline();

		mapContainer.classList.remove('js-open-btn-next');
		incrementQuestion();

		mapWrap.classList.remove('pointer-events-none');

		if (currentQuestion === allQuestions) {
			previewBanner.classList.add('-second');
			// const correctCount = Array.from(mapItems).filter((item) => item.classList.contains('is-correct')).length;

			let titleText;
			if (correctCount >= 4) {
				// titleText = contentMap[currentQuestion].titleFirstBannerCorrect;
				titleText = 'You’re a Seasoned Culinary Traveler!';

				document.body.dispatchEvent(
					new CustomEvent('data-analytics', {
						detail:
							'2024-sia-culinary-' +
							(window.currentType === 'business' ? 'shanti' : 'etienne') +
							'-screenendA',
					}),
				);
			} else {
				// titleText = contentMap[currentQuestion].titleFirstBannerWrong;
				titleText = 'You’re a Budding Food Explorer!';

				document.body.dispatchEvent(
					new CustomEvent('data-analytics', {
						detail:
							'2024-sia-culinary-' +
							(window.currentType === 'business' ? 'shanti' : 'etienne') +
							'-screenendB',
					}),
				);
			}

			const titleFirstBanner = container.querySelector('[data-banners="titleFirstBanner"]');
			if (titleFirstBanner) {
				titleFirstBanner.textContent = titleText;
			}
			timelineLast
				.to(
					mapContainer,
					{
						duration: 0.5,
						opacity: 0,
						ease: 'power2.out',
						onComplete: () => {
							mapContainer.classList.remove('is-active');
							mapContainer.classList.add('is-hidden');
						},
					},
					0,
				)
				.to(
					previewBanner,
					{
						duration: 1,
						opacity: 1,
						ease: 'power2.out',
						onComplete: () => {
							previewBanner.classList.add('is-active');
							previewBanner.classList.remove('is-hidden');
						},
					},
					0.5,
				);
			return;
		}

		gsap.to(isTablet ? mapMobileScroll : mapContentInner, {
			scrollTo: 0,
			duration: 0.5,
			ease: 'power2.out',
			onComplete: () => {
				slideQuestion();
			},
		});

		console.log(currentQuestion);

		document.body.dispatchEvent(
			new CustomEvent('data-analytics', {
				detail:
					'2024-sia-culinary-' +
					(window.currentType === 'business' ? 'shanti' : 'etienne') +
					'-screen' +
					(currentQuestion * 2 + 1),
			}),
		);

		ev('nextQuestion', {
			mapCenter: currentContent[currentQuestion].mapCenter,
			zoom: currentContent[currentQuestion].zoomMobile,
		});

		function slideQuestion() {
			const step = currentQuestion * 100;
			timelineClose.to(infoList, {
				duration: 0.6,
				xPercent: -step,
				opacity: 1,
				ease: 'power2.out',
				onComplete: () => {
					infoListItems[currentQuestion - 1].classList.add('is-not-active');
				},
			});
		}
	});

	function resetQuiz(question) {
		currentQuestion = 0;
		correctCount = 1;

		gsap.to(previewBanner, {
			opacity: 1,
		});

		gsap.to(mapContainer, {
			opacity: 0,
		});

		previewBanner.classList.remove('-second');
		previewBanner.classList.remove('is-hidden');
		mapContainer.classList.remove('is-active');
		backBtn.classList.remove('is-active');
		mapBox.classList.remove('is-shadow-hidden');
		$($btnDish).removeClass('is-correct is-incorrect');
		$(infoListItems).removeClass('js-open-content');
		mapContainer.classList.remove('js-open-btn-next');
		mapWrap.classList.remove('pointer-events-none');

		const titleFirstBanner = container.querySelector('[data-banners="titleFirstBanner"]');
		if (titleFirstBanner) {
			titleFirstBanner.textContent = 'A Culinary Journey';
		}

		gsap.to(infoList, {
			xPercent: 0,
		});

		ev('nextQuestion', { mapCenter: question.mapCenter, zoom: question.zoomMobile });
	}

	window.resetQuiz = resetQuiz;

	const backBtn = container.querySelector('.back-btn');

	backBtn.addEventListener('click', hideCulinary);
	document.querySelector('[data-back-to-film]').addEventListener('click', hideCulinary);

	function hideCulinary(e) {
		e.preventDefault();
		e.stopPropagation();

		mapContainer.classList.remove('is-active');
		$('.quiz').addClass('is-hidden-component');

		ev('showBurgerBtn', {});
		ev('showVideo', { paused: !window.isVideoOverlayShown });
		ev('backToVideo');

		destroyLottie();
	}

	document.addEventListener('showCulinary', (e) => {

		window.currentType = e.detail.type;
		ev('hideVideo', { isCulinary: true });
		$('.quiz').removeClass('is-hidden-component');

		currentContent = e.detail.type == 'premium' ? premiumContentMap : contentMap;
		window.currentMapContent = currentContent;
		resetQuiz(currentContent[0]);

		// map.flyRi;

		infoList.innerHTML = '';

		for (let i = 0; i < allQuestions; i++) {
			const mapItemHtml = mapItemTemplate(currentContent[i]);
			infoList.innerHTML += mapItemHtml;
		}

		updateVariables();
		attachEvents();
		animateHero();
	});

	function animateHero() {
		addHeroContentAnimation(heroTimeline, container, 0.5, playLottie);

		console.log(heroTimeline);

		if (heroTimeline) {
			heroTimeline.restart();
		}

		initLottie(0);
	}

	function initLottie(timeout = 300) {
		setTimeout(() => {
			if (!lottieAnimations) {
				lottieAnimations = lottieCulinary();
			}
		}, timeout);
	}

	function playLottie() {
		lottieAnimations.animationCulinaryOne.play();
		lottieAnimations.animationCulinaryTwo.play();
	}

	function destroyLottie() {
		if (lottieAnimations) {
			lottieAnimations.animationCulinaryOne.goToAndStop(0);
			lottieAnimations.animationCulinaryTwo.goToAndStop(0);
		}
	}

	function updateVariables() {
		headerTxt = container.querySelectorAll('[data-banners="headerTxt"]');
		infoListItems = infoList.querySelectorAll('[data-banners="infoListItem"]');
		question = container.querySelectorAll('[data-banners="question"]');
		btnToHint = container.querySelectorAll('[data-banners="btnToHint"]');
	}

	function attachEvents() {
		btnToHint.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				if (!infoListItems[currentQuestion].classList.contains('js-open-hint')) {
					infoListItems[currentQuestion].classList.add('js-open-hint');
					setTimeout(() => {
						infoListItems[currentQuestion].classList.add('js-open-hint-anim');
					}, 500);
				} else {
					infoListItems[currentQuestion].classList.remove('js-open-hint');
					setTimeout(() => {
						infoListItems[currentQuestion].classList.remove('js-open-hint-anim');
					}, 500);
				}
			});
		});

		document.querySelectorAll('[data-banners="blockOpenText"]').forEach((block) => {
			const blockInner = block.querySelector('.block-open-text_inner');
			let content;

			if (blockInner) {
				content = blockInner.textContent.trim();
			}

			if (!content || content === 'undefined') {
				block.classList.add('is-hidden');
				const btn = block.closest('[data-banners="text"]').querySelector('[data-banners="btnOpenText"]');
				btn.classList.add('is-hidden');
			}
		});

		document.querySelectorAll('[data-banners="btnOpenText"]').forEach((btn) => {
			btn.addEventListener('click', () => {
				const block = btn.closest('[data-banners="text"]').querySelector('[data-banners="blockOpenText"]');
				const blockInner = block.querySelector('.block-open-text_inner');
				// const mapContentInner = document.querySelector('.mapContentInner'); // Adjust this selector to match your HTML structure

				if (!btn.classList.contains('is-active')) {
					btn.classList.add('is-active');
					gsap.to(block, { height: blockInner.scrollHeight, duration: 0.5 });
				} else {
					btn.classList.remove('is-active');
					gsap.to(block, { height: 0, duration: 0.5 });
				}

				// Scroll mapContentInner to the bottom
				if (mapContentInner) {
					setTimeout(() => {
						mapContentInner.scrollTo({
							top: mapContentInner.scrollHeight,
							behavior: 'smooth',
						});
					}, 500);
				}
			});
		});
	}

	btnShow.addEventListener('click', (e) => {
		e.preventDefault();
		previewBanner.classList.add('is-hidden');
		mapContainer.classList.add('is-active');

		backBtn.classList.add('is-active');

		const timelineOpen = gsap.timeline();

		timelineOpen
			.to(
				previewBanner,
				{
					duration: 0.5,
					opacity: 0,
					ease: 'power2.out',
					onComplete: () => {
						previewBanner.classList.add('is-hidden');
					},
				},
				0,
			)
			.to(
				mapContainer,
				{
					duration: 1,
					opacity: 1,
					ease: 'power2.out',
				},
				0.5,
			)
			.to(
				mapContent,
				{
					x: '0%',
					force3D: true,
					duration: 0.6,
					ease: 'power2.out',
					onComplete: () => mapContent.classList.add('is-active'),
				},
				1,
			)
			.to(
				mapOverlayText,
				{
					opacity: 1,
					x: 0,
					duration: 1,
					ease: 'power2.out',
				},
				1,
			)
			.to(
				mapOverlayText,
				{
					opacity: 0,
					duration: 0.5,
					ease: 'power2.out',
					onComplete: () => mapBox.classList.add('is-shadow-hidden'),
				},
				4,
			);
	});

	mapOverlayText.addEventListener('click', (e) => {
		gsap.to(mapOverlayText, {
			opacity: 0,
			duration: 0.5,
			ease: 'power2.out',
			onComplete: () => mapBox.classList.add('is-shadow-hidden'),
		});
	});

	function showAnswer() {
		mapContainer.classList.add('js-open-btn-next');
		infoListItems[currentQuestion].classList.add('js-open-content');
		setTimeout(() => {
			infoListItems[currentQuestion].classList.add('js-open-content-anim');
		}, 300);

		document.body.dispatchEvent(
			new CustomEvent('data-analytics', {
				detail:
					'2024-sia-culinary-' +
					(window.currentType === 'business' ? 'shanti' : 'etienne') +
					'-screen' +
					(currentQuestion + 1) * 2,
			}),
		);
	}

	document.addEventListener('countryClick', (e) => {
		const countryName = e.detail.countryName;

		mapWrap.classList.add('pointer-events-none');

		const headerTxtHeight = headerTxt[currentQuestion].offsetHeight;
		const isCorrect = currentContent[currentQuestion].nameCountry.includes(countryName);
		if (isCorrect) correctCount++;

		// mapItem.classList.add(isCorrect ? 'is-correct' : 'is-incorrect');
		$btnDish[currentQuestion].classList.add(isCorrect ? 'is-correct' : 'is-incorrect');

		ev('selectCountry', { isCorrect, correctAnswer: currentContent[currentQuestion].nameCountry });

		showAnswer();

		const headerTxtHeight1 = headerTxtHeight;
		const questionHeight = question[currentQuestion].offsetHeight;
		const headerTxtHeight2 = headerTxt[currentQuestion].offsetHeight - questionHeight;
		gsap.fromTo(
			headerTxt[currentQuestion],
			{
				height: headerTxtHeight1,
			},
			{
				height: headerTxtHeight2,
				duration: 0.5,
				ease: 'power2.out',
			},
		);
	});
};
